export default {
  defaultProps: {
    disablePadding: true,
  },
};
